var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayment2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.43,
    height: 30.37,
    viewBox: "0 0 26.43 30.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "payment-_2_",
    transform: "translate(-40 503.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2654",
    "data-name": "Path 2654",
    d: "M53.635-503.666a2.884,2.884,0,0,0-1.207.711,3.177,3.177,0,0,0-.441.68l-.2.41-.018,6.168-.012,6.174h-.386c-.686,0-.888.1-2.56,1.274-.858.6-1.795,1.25-2.083,1.439a5.728,5.728,0,0,0-.888.735c-.2.208-.894,1.158-1.55,2.095s-1.286,1.819-1.409,1.948c-.331.355-.613.466-1.691.692-.784.159-1,.227-1.084.331-.1.129-.11.386-.11,3.749v3.608l.153.153.153.153,4.974-.018,4.98-.018.429-.153a4.18,4.18,0,0,0,.839-.429c.221-.153,1.36-1.17,2.524-2.266l2.119-1.991,4.214-.031,4.208-.031.41-.2a2.354,2.354,0,0,0,1.2-1.17l.227-.466v-21.757l-.227-.466a2.354,2.354,0,0,0-1.2-1.17l-.41-.2-5.36-.012C56.122-503.721,53.776-503.7,53.635-503.666Zm1.8,1.464a1.644,1.644,0,0,0,.778,1.207l.294.172h5.206l.276-.153a1.661,1.661,0,0,0,.8-1.219l.135-.557h.643a4.392,4.392,0,0,1,.9.074,1.819,1.819,0,0,1,.943.943c.1.368.1,21.12,0,21.487a1.819,1.819,0,0,1-.943.943,35.372,35.372,0,0,1-3.73.073H57.249l.717-.68c.9-.851,1.115-1.231,1.115-1.954a3.058,3.058,0,0,0-.049-.631l-.043-.165h1.384a9.684,9.684,0,0,0,1.642-.073,1.819,1.819,0,0,0,.943-.943,3.572,3.572,0,0,0,0-1.4,1.819,1.819,0,0,0-.943-.943,53.977,53.977,0,0,0-5.807,0,1.755,1.755,0,0,0-.949.98,4.491,4.491,0,0,0,.006,1.4,6.9,6.9,0,0,1-1.219,1.145c-.68.582-1.25,1.054-1.268,1.054s-.037-4.508-.037-10.021c0-7.693.018-10.082.074-10.278a1.953,1.953,0,0,1,.907-.937,4.977,4.977,0,0,1,.894-.073l.686-.006Zm6.395-.2a1.039,1.039,0,0,1-.245.49c-.153.141-.153.141-2.475.141s-2.321,0-2.475-.141a1.039,1.039,0,0,1-.245-.49l-.086-.349h5.611ZM51.76-487.2v1.335l-1.041.625a3.925,3.925,0,0,0-1.213.876l-.165.251-.018,2.156-.018,2.15.172.331a1.213,1.213,0,0,0,1.176.7,1.506,1.506,0,0,0,.588-.1c.1-.055,1.231-.986,2.511-2.076,1.341-1.133,2.444-2.021,2.6-2.095a1.093,1.093,0,0,1,.625-.086,1.171,1.171,0,0,1,1.139,1.09c.055.606.025.643-3.5,3.951-1.752,1.642-3.314,3.087-3.473,3.216a3.382,3.382,0,0,1-.643.374l-.355.141-4.576.018-4.582.018V-480.3l.723-.141a3.217,3.217,0,0,0,1.819-.833c.172-.171.845-1.084,1.5-2.027,1.317-1.893,1.666-2.3,2.3-2.713.239-.153,1.115-.76,1.948-1.348s1.6-1.09,1.684-1.115a2,2,0,0,1,.49-.055l.319-.006ZM61.9-484.959c.135.129.153.2.153.582s-.018.453-.153.582l-.147.153H58.345l-.453-.227a1.648,1.648,0,0,0-1.09-.233l-.631.006v-.361c0-.294.025-.38.153-.5l.147-.153h5.28ZM51.76-482.644v2.1l-.5.41c-.521.429-.7.49-.876.3-.092-.1-.1-.318-.086-2.07l.018-1.948.7-.441c.386-.245.711-.447.723-.447S51.76-483.8,51.76-482.644Z",
    transform: "translate(0 0)",
    fill: "#1b1be1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2655",
    "data-name": "Path 2655",
    d: "M264.153-407.847c-.153.147-.153.165-.153,1.225v1.072h.98v-1.47h1.47V-408h-1.072C264.319-408,264.3-408,264.153-407.847Z",
    transform: "translate(-210.28 -89.853)",
    fill: "#1b1be1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2656",
    "data-name": "Path 2656",
    d: "M400-407.522v.49h1.47v1.47h.98v-1.072c0-1.458.08-1.378-1.378-1.378H400Z",
    transform: "translate(-337.949 -89.841)",
    fill: "#1b1be1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2657",
    "data-name": "Path 2657",
    d: "M288.131-383.869c-.153.147-.153.159-.153,1.317,0,1.574-.1,1.47,1.47,1.47,1.158,0,1.17,0,1.317-.153s.153-.159.153-1.317c0-1.574.1-1.47-1.47-1.47C288.291-384.022,288.278-384.022,288.131-383.869Zm1.807,1.317v.49h-.98v-.98h.98Z",
    transform: "translate(-232.788 -112.361)",
    fill: "#1b1be1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2658",
    "data-name": "Path 2658",
    d: "M344-383.51v.49h.98V-384H344Z",
    transform: "translate(-285.379 -112.383)",
    fill: "#1b1be1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2659",
    "data-name": "Path 2659",
    d: "M368.131-383.869c-.153.147-.153.159-.153,1.317,0,1.574-.1,1.47,1.47,1.47,1.158,0,1.17,0,1.317-.153s.153-.159.153-1.317c0-1.574.1-1.47-1.47-1.47C368.291-384.022,368.278-384.022,368.131-383.869Zm1.807,1.317v.49h-.98v-.98h.98Z",
    transform: "translate(-307.888 -112.361)",
    fill: "#1b1be1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2660",
    "data-name": "Path 2660",
    d: "M344-351.265v.735h.98V-352H344Z",
    transform: "translate(-285.379 -142.423)",
    fill: "#1b1be1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2661",
    "data-name": "Path 2661",
    d: "M288.153-327.847c-.153.147-.153.165-.153,1.225v1.072h.98v-1.47h.98V-328h-.827C288.331-328,288.294-327.994,288.153-327.847Z",
    transform: "translate(-232.809 -164.952)",
    fill: "#1b1be1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2662",
    "data-name": "Path 2662",
    d: "M368-327.51v.49h.49v2.45h.98v-.98h1.47v-.98h-1.47v-.49h1.47V-328H368Z",
    transform: "translate(-307.909 -164.952)",
    fill: "#1b1be1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2663",
    "data-name": "Path 2663",
    d: "M321.47-311.265v.735H320v.98h1.072c1.458,0,1.378.08,1.378-1.378V-312h-.98Z",
    transform: "translate(-262.849 -179.972)",
    fill: "#1b1be1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2664",
    "data-name": "Path 2664",
    d: "M263.988-286.928c0,1.458-.08,1.378,1.378,1.378h1.072v-.98h-1.47V-288h-.98Z",
    transform: "translate(-210.268 -202.502)",
    fill: "#1b1be1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2665",
    "data-name": "Path 2665",
    d: "M401.47-287.265v.735H400v.98h1.072c1.458,0,1.378.08,1.378-1.378V-288h-.98Z",
    transform: "translate(-337.949 -202.502)",
    fill: "#1b1be1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment2);
export default __webpack_public_path__ + "static/media/payment-_2_.ad52054fd8cabc0eef96a4a084b2cb86.svg";
export { ForwardRef as ReactComponent };